<template>
	<div class="resume">
		<el-container>
			<el-header class="personalheader">
				<div class="nidrlogo">
					<img src="../../image/zsdb_logo.png" />
				</div>
				<div class="accoutInfo">
					<span class="headerText">尊敬的用户{{showId}}，您好！</span>
					<span class="divider">|</span>
					<el-link type="primary" class="headerText" @click="gotohome()">招聘首页</el-link>
					<span class="divider">|</span>
					<el-link type="primary" @click="exit()" class="headerText">退出</el-link>
				</div>
			</el-header>
			<el-container>
				<el-aside class="personalaside">
					<el-menu default-active="2" class="personalmenu" background-color="#545c64" text-color="#fff"
						active-text-color="#ffd04b">
						<el-menu-item index="1" @click="gotoresume()">
							<span class="menuText" slot="title">个人简历</span>
						</el-menu-item>
						<el-menu-item index="2" @click="gotocollect()">
							<span class="menuText" slot="title">已收藏岗位</span>
						</el-menu-item>
						<el-menu-item index="3" @click="gotosubmit()">
							<span class="menuText" slot="title">我的投递</span>
						</el-menu-item>
					</el-menu>
				</el-aside>
				<el-main class="personalbody">
					<div class="resumecontent">
						<el-table :data="collectResumuList" stripe style="width: 100%">
							<template slot="empty">
								<img src="../../image/noneposition.png" class="nonepositionimgPersonal" />
								<div class="noCart">
									收藏岗位空空如也，快去看看岗位列表吧！
									<router-link to="/">前去查看</router-link>
								</div>
							</template>
							<el-table-column prop="position_name" label="岗位名称">
							</el-table-column>
							<!-- <el-table-column prop="base" label="地址">
							</el-table-column>
							<el-table-column prop="department" label="招聘单位">
							</el-table-column> -->
							<el-table-column prop="contact" label="联系人">
							</el-table-column>
							<el-table-column label="查看" width="100">
								<template slot-scope="scope">
									<el-button @click="dialogPositionInfo(scope.row)" icon="el-icon-search" type="text"
										size="small">查看
									</el-button>
								</template>
							</el-table-column>
							<el-table-column label="操作" width="100">
								<template slot-scope="scope">
									<el-button @click="requestPositionSelect(scope.row)" type="text" size="small">投递
									</el-button>
									<el-button type="text" size="small" @click="deleteCollec(scope.row)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
						<el-dialog title="岗位信息" :visible.sync="dialogPositionStats" width="40%">
							<div class="temtitle">
								<div class="jobnamePersonal">岗位名称： &nbsp&nbsp{{requestPositionInfo.position_name}}</div>
								<!-- <div class="positionInfo">
									招聘单位： <br />
									<span class="info">
										&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{requestPositionInfo.department}}
									</span>
								</div><br />
								<div class="positionInfo">
									工作地点： <br />
									<span class="info">
										&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{requestPositionInfo.base}}
									</span>
								</div><br />
								<div class="positionInfo">
									发布时间： <br />
									<span class="info">
										&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{requestPositionInfo.update_time}}
									</span>
								</div><br />
								<div class="positionInfo">
									任职资格：<br />
									<span class="info">
										&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{requestPositionInfo.requirements}}
									</span>
								</div><br /> -->
								<!-- <div class="positionInfo">
									工作职责： <br />
									<span class="info">
										&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{requestPositionInfo.responsibilities}}
									</span>
								</div><br /> -->
								<div class="positionInfo">
									招聘条件： <br />
									<span class="info" style="white-space: pre-wrap;">
										{{requestPositionInfo.responsibilities}}
									</span>
								</div><br />
								<div class="positionInfo">
									联系人： <br />
									<span class="info">
										&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{requestPositionInfo.contact}}
									</span>
								</div><br />
							</div>
							<span slot="footer" class="dialog-footer">
								<el-button @click="dialogPositionStats = false">关 闭</el-button>
								<!-- <el-button type="primary" @click="requestPositionFromDialog()">投 递</el-button> -->
								<el-button type="primary" @click="requestPosition()">投 递</el-button>
							</span>
						</el-dialog>
						<el-dialog title="投递确认" :visible.sync="requestOrderDialog" width="30%">
							<el-radio-group v-model="order">
								<el-radio label="0">第一志愿</el-radio>
								<el-radio label="1">第二志愿</el-radio>
							</el-radio-group>
							<span slot="footer" class="dialog-footer">
								<el-button @click="closeRequestOrderDialog()">取 消</el-button>
								<el-button type="primary" @click="requestPosition()">确 定</el-button>
							</span>
						</el-dialog>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<div class="footer">
			<div class="container">
				<p>&copy 2022 Inc. All Rights Reserved. 中水东北勘测设计研究有限责任公司 版权所有 吉ICP备2022003947号-1
					技术支持：中水东北勘测设计研究有限责任公司数字与智慧工程院
					<br />吉公网安备 22010402001082号
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		loginstatus,
		Logout,
		queryCollectionPosition,
		requestPosition,
		deleteCollectionPosition,
	} from '../../api/user.js';
	export default {
		data() {
			return {
				dialogPositionStats: false,
				requestOrderDialog: false,
				requestPositionInfo: {},
				collectResumuList: [],
				userId: '',
				showId: '',
				order: null,
			}
		},
		mounted() {
			loginstatus().then((res) => {
				if (res.code == 200) {
					let str = res.data;
					this.showId = str.substring(0, 3) + '****' + str.substring(7, 11);
					this.userId = res.data;
					queryCollectionPosition({
						userID: this.userId,
					}).then((res) => {
						this.collectResumuList = res.data;
					})
				} else if (res.code == 400) {
					this.$message({
						message: '未检测到登录信息！',
						type: 'error'
					});
					this.$router.push('/')
				}
			})
		},
		methods: {
			requestPositionFromDialog() {
				this.requestOrderDialog = true;
			},
			dialogPositionInfo(row) {
				this.requestPositionInfo = row;
				this.dialogPositionStats = true
				this.requestPositionInfo.update_time = timestampToTime(this.requestPositionInfo.update_time)
			},
			deleteCollec(row) {
				this.$confirm('此操作将删除该收藏的岗位, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteCollectionPosition({
						positionID: row.position_id,
						userID: this.userId,
					}).then((res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							location.reload();
						} else {
							this.$message({
								message: '删除失败！',
								type: 'error'
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			closeRequestOrderDialog() {
				this.dialogPositionStats = false;
				this.requestOrderDialog = false;
			},
			requestPosition() {
				// if (this.order == null) {
				// 	this.$message({
				// 		message: '请选择投递顺序！',
				// 		type: 'warning'
				// 	});
				// } else {
				this.$confirm('岗位投递后将不可再进行修改，请确认无误后投递。', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					requestPosition({
						order: 0,
						positionID: this.requestPositionInfo.position_id,
						userID: this.userId,
					}).then((res) => {
						this.dialogPositionStats = false;
						this.requestOrderDialog = false
						if (res.code == 200) {
							this.$message({
								message: '投递成功！',
								type: 'success'
							});
						} else if (res.code == 40098) {
							this.$confirm('您尚未完善与提交简历，若需投递岗位请先前往个人中心创建您的简历', '提示', {
								confirmButtonText: '前往个人中心',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								this.$router.push('/personal/resume')
							}).catch(() => {

							});
						} else if (res.code == 40099) {
							this.$message({
								message: '简历类型与所投岗位类型不匹配！',
								type: 'error'
							});
						} else if (res.code == 50099) {
							this.$message({
								message: '岗位不存在！',
								type: 'error'
							});
						} else if (res.code == 40002) {
							this.$message({
								message: '用户已申请两个岗位，请调整！',
								type: 'error'
							});
						} else if (res.code == 40003) {
							this.$message({
								message: '此位置申请已存在！',
								type: 'error'
							});
						} else if (res.code == 48848) {
							this.$message({
								message: res.msg,
								type: 'error'
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消投递'
					});
				});

				// }
			},
			requestPositionSelect(row) {
				// this.requestOrderDialog = true;
				this.requestPositionInfo = row;
				this.requestPositionInfo.update_time = timestampToTime(this.requestPositionInfo.update_time)
				this.requestPosition()
			},
			exit() {
				Logout().then((res) => {
					this.$router.push('/')
				})
			},
			gotohome() {
				this.$router.push('/')
			},
			gotoresume() {
				this.$router.push('/personal/resume')
			},
			// gotocollect() {
			// 	this.$router.push('/personal/collect')
			// },
			gotosubmit() {
				this.$router.push('/personal/submit')
			},
		},
	}

	function timestampToTime(timestamp) {
		timestamp = timestamp ? timestamp : null;
		let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
		let Y = date.getFullYear() + '-';
		let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
		let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
		return Y + M + D;
	}
</script>

<style>
	@import url(../../assets/css/personal.css);

	.resumecontent {
		margin-left: 10%;
		width: 80%;
		background-color: white;
		border-radius: 2px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
	}
</style>
